module.exports = __webpack_public_path__ + "static/media/09.e392371e.jpg";